import CircularChart from './CircularChart';

export default CircularChart;
